import store from "@/store";

export function parentEnvironmentId() {
  return store.state.login.user.environment_id;
}

export default {
  parentEnvironmentId: parentEnvironmentId
};
